module.exports = __webpack_public_path__ + "assets/img/estimation-new.dc71d1f6.svg";